import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const CaseStudiesCTA = () => {
  return (
    <section className="py-24 px-4 bg-foreground">
      <div className="max-w-3xl mx-auto text-center">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-background mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Want Results Like These?
        </motion.h2>
        <motion.p
          className="text-lg text-muted mb-8"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
        >
          We'll show you exactly how to improve your lead flow and conversion system.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          <Link to="/demo">
            <Button size="lg" className="text-base px-10 py-6">
              Get a Free Audit
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
